import { Component, OnInit } from "@angular/core";
import { NgForm, FormGroup, FormBuilder } from "@angular/forms";
import { ReactiveFormsModule, FormControl } from "@angular/forms";
import { DataService } from "src/app/service/buildings.service";
import { Router } from "@angular/router";
import { BuyComponent } from "src/app/buy/buy.component";

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"]
})
export class FilterComponent implements OnInit {
  keyword: string;

  sortByAll = [];
  buildTypeList = [];

  myForm: FormGroup;
  constructor(
    private data: DataService,
    private fb: FormBuilder,
    private router: Router,
    private buy: BuyComponent
  ) {
    console.log("Hey, I am here!");
  }

  ngOnInit() {
    this.data.currentMessage.subscribe(keyword => (this.keyword = keyword));
    console.log("filter 1:" + this.keyword);
  }

  onCheckboxsortByAll(option) {
    let lengthx = this.sortByAll.length;
    let check = false;
    if (lengthx > 0) {
      for (var i = 0; i < lengthx; i++) {
        if (this.sortByAll[i] == option) {
          this.sortByAll.splice(i, 1);
          check = true;
        }
      }
      if (!check) this.sortByAll.push(option);
    } else {
      this.sortByAll.push(option);
    }
   
  }

  newMessage(form: NgForm) {
    console.log("price:" + form.value.priceValue);
    console.log("beds:" + form.value.bedsValue);
    this.data.changePrice(form.value.priceValue);
    this.data.changeMessage(form.value.keyword);
    this.data.changeBed(form.value.bedsValue);
    this.data.changeSortByAll(this.sortByAll);
    this.data.changebuildingType(this.buildTypeList);


    this.buy.filterK();
    // this.router.navigateByUrl('/buy');
  }

  filterListingType = new FormControl();

  
  filterListingTypeItems = [
    {
      group: "For sale",
      options: [
        "For sale"
        // "By Agent",
        // "By ownre",
        // "New Construction",
        // "Foreclosures",
        // "Coming Soon"
      ],
      optionid: 3
    },
    // {
    //   group: "Potential listings",
    //   options: [
    //     "Potential listings",
    //     "Foreclosed",
    //     "Pre-Foreclosure",
    //     "Make Me Move"
    //   ]
    // },
    {
      group: "For Rent",
      options: ["For Rent"],
      optionid: 4
    }
    // {
    //   group: "Recently sold",
    //   options: ["Recently sold"]
    // },
    // {
    //   group: "_________________________",
    //   options: ["Open House only", "Pending & Under Contract"]
    // }
  ];

  filterHomeType = new FormControl();

  filterHomeTypeItems = [
    {
      title:["Houses"],
      id:9
    },
    {
      title:["Apartments"],
      id:16
    },
    {
      title:["Townhomes"],
      id:5
    },
    {
      title:["Manufactured"],
      id:17
    },
    {
      title:["Lost/Land"],
      id:3
    },
   
  ];

  onCheckboxBuild(filterHomeTypeItem) {
    let lengthx = this.buildTypeList.length;
    let f = false;

    if (lengthx > 0) {
      for (var i = 0; i < lengthx; i++) {
        if (this.buildTypeList[i] == filterHomeTypeItem) {
          this.buildTypeList.splice(i, 1);
          f = true;
        }
      }
      if (f == false) {
   
        this.buildTypeList.push(filterHomeTypeItem);
      }
    } else {
      if (f == false) {
      
       this.buildTypeList.push(filterHomeTypeItem);
      }
    }
 console.log("/******************************/")
    for (var i = 0; i < this.buildTypeList.length; i++) {
        console.log(this.buildTypeList[i]);
    

    }

    console.log("/******************************/")
  }
}
